'use strict';
var global = require('../internals/global');
var classof = require('../internals/classof-raw');

module.exports = classof(global.process) === 'process';



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/engine-is-node.js
// module id = 469
// module chunks = 0